import { render, staticRenderFns } from "./CourseImage.vue?vue&type=template&id=5a2ea060&scoped=true&"
import script from "./CourseImage.vue?vue&type=script&lang=ts&"
export * from "./CourseImage.vue?vue&type=script&lang=ts&"
import style0 from "./CourseImage.vue?vue&type=style&index=0&id=5a2ea060&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ea060",
  null
  
)

export default component.exports